import { MPA_TRANSACTIONS_APPLY_REQUEST, MPA_TRANSACTIONS_APPLY_SUCCESS, MPA_TRANSACTIONS_APPLY_FAILURE } from './types/ManualPreadviceTransactionsApplyActionsTypes';

export function postManualPreadviceTransactionsApplyRequestActionCreator(context,
  newTransactionIds) {
  return {
    type: MPA_TRANSACTIONS_APPLY_REQUEST,
    payload: {
      appContext: context,
      params: {
        transactionIds: newTransactionIds,
      },
    },
  };
}

export function postManualPreadviceTransactionsApplySuccessActionCreator(data) {
  return {
    type: MPA_TRANSACTIONS_APPLY_SUCCESS,
    payload: data,
  };
}

export function postManualPreadviceTransactionsApplyFailureActionCreator(error) {
  return {
    type: MPA_TRANSACTIONS_APPLY_FAILURE,
    payload: error,
    error: true,
  };
}
